import DataModule from "@/components/DataModule";
import { inr } from "@/lib/api";
import { MEASURING_UNITS } from "@/lib/units";

const SERVICE_CATEGORIES = [
  "Painting", "Interior Design", "Wood Work", "Wardrobe", "Kitchen",
  "Door Installation", "False Ceiling", "Electrical", "Plumbing", "Civil Work",
  "Flooring", "Tiling", "POP", "Glass Work", "Curtains", "Other",
];

export default function Services() {
  return (
    <DataModule
      title="Services"
      subtitle="Service catalogue for interior, contracting & repair work"
      endpoint="services"
      pageTestId="services-page"
      initialRecord={{ gst_percent: 18, unit: "Sq.ft" }}
      fields={[
        { key: "name", label: "Service Name", required: true },
        { key: "category", label: "Category", type: "select", options: SERVICE_CATEGORIES },
        { key: "unit", label: "Unit", type: "select", options: MEASURING_UNITS },
        { key: "price", label: "Price per Unit", type: "number" },
        { key: "gst_percent", label: "GST %", type: "number" },
        { key: "duration", label: "Estimated Duration" },
        { key: "description", label: "Description", type: "textarea", full: true },
      ]}
      columns={[
        { key: "name", label: "Service", render: (s) => <span className="font-medium">{s.name}</span> },
        { key: "category", label: "Category" },
        { key: "unit", label: "Unit" },
        { key: "price", label: "Price", render: (s) => `${inr(s.price)} / ${s.unit || "unit"}` },
        { key: "gst_percent", label: "GST", render: (s) => `${s.gst_percent || 0}%` },
      ]}
    />
  );
}
